import { useEffect, useState } from 'react';
import api from '../../../../../api';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Scope = () => {
 
  const [scopeSection, setScopeSection] = useState({});
 const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

     useEffect(() => {
         if (typeof window !== 'undefined') {
             const AOS = require('aos');
             AOS.init({
                 duration: 1000,
                 once: true
             });
         }
     }, []);


  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await api.get('/api/pages/center');
        const groupData = response.data.groups;
        const scope_section = groupData[3].scope_section;

         setScopeSection(scope_section);
       
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCarouselData();
  }, []);



  return (
    <section className="mb-3 mb-md-5">
      <div className="container">
        <div className="row">
          <h2
            className="sec-title text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
          {scopeSection.heading}
          </h2>
        </div>

        <div className="row">
         <div className="col-md-10 offset-md-1">
  <ul className="list-unstyled p-3">
    {scopeSection?.scope_points?.map((point, index) => (
      <li
        key={index}
        className="mb-3"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay={index * 100} // adds delay dynamically
      >
        {/* Use warning icon only for last item, else use check-circle */}
        <i
          className={`me-2 fa ${
            index === scopeSection.scope_points.length - 1
              ? "fa-exclamation-triangle"
              : "fa-check-circle-o"
          }`}
        ></i>
        {point}
      </li>
    ))}
  </ul>
</div>

        </div>
      </div>
    </section>
  );
};

export default Scope;